/*
* Reserve study report - percent funded section componet
*/

import * as React from 'react';

import { Formatters } from '../common/formatters';

export const PercentFundedSection = ({ appText, percentFunded, isHypothetical, fullyFunded, fundingAmount, ...rest }) => {
    if (!appText) { return (<div />); }

    const caption = (isHypothetical) ? appText('hypothetical-percent-funded') : appText('percent-funded');
    const formatted = Formatters.formatPercentage(percentFunded, 2);

    const captionFundingAmount = (isHypothetical) ? appText('hypothetical-funding-amount') : appText('funding-amount');
    const amountAsString = Formatters.formatCurrencyIntl(fundingAmount);

    const captionFullyFunded = (isHypothetical) ? appText('hypothetical-fully-funded') : appText('fully-funded');
    const fullyFundedAsString = Formatters.formatCurrencyIntl(fullyFunded);

    return (
        <div className="percent-funded">
            <h4>{caption}: {formatted}</h4>
            {(fullyFunded && fundingAmount) ? (<h5>{amountAsString} / {fullyFundedAsString}</h5>) : (<div />)}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/report/percentfundedsection.tsx